import styled from "styled-components";
import { Button, Checkbox as CheckboxBase } from "antd";

export const Checkbox = styled(CheckboxBase)`
  + .ant-checkbox-wrapper {
    margin-left: 0;
  }
`;

export const ClearAllButton = styled(Button)`
  padding: 0;
  height: 0;
`;
